import Header from "../Header";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {submitStep} from "../../network";
import ReactGA from "react-ga";

const Thanks = ({nextStep, currentFormStep, maxStep}) => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + "/thanks");
    }, []);
    const [isLoading, setLoading] = useState(false);
    const {register, handleSubmit, errors} = useForm();
    const onSubmit = handleSubmit((data) => {
        setLoading(true);
        submitStep("thanks", data).then(() => {
            setLoading(false);
            nextStep();
        });
    });
    return (<>
        <Header title="Suur aitäh!"/>
        <progress className="progress is-link" value={currentFormStep} max={maxStep}/>
        <section className="section">
            <div className="container">
                <h1 className="subtitle">
                    Aitäh, et võtsid aega! Vaatan põnevusega otsa Su arvamustele!
                </h1>
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/K8ULqMrrquw?showinfo=0" frameborder="0"
                            allowfullscreen/>
                </figure>
                <p className="text">
                    NB! Kui vastasid mõnes kohas, et Sul on tõsine, lahendamist vajav mure, siis ole hea, kirjuta mulle kasvõi kohe ago.luberg@taltech.ee ja otsime lahenduse.
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Mis Sa sellisest tutvustamise protsessist arvad?
                </h1>
                <p className="text">
                    Oleme väga tänulikud, et jõudsid siia! Võtame julguse küsida ühe küsimuse veel:
                </p>
            </div>
            <form className="container" onSubmit={onSubmit}>
                <h1 className="subtitle form-question">
                    Kuidas Sulle selline protsess meeldis?
                </h1>
                <p className="text">Vali hinnang skaalal 0-10</p>
                <div className="select">
                    <select name="processRating" ref={register({required: true})}>
                        <option value="null" selected disabled>Vali</option>
                        <option value="10">10 - meeldis väga</option>
                        <option value="9">9</option>
                        <option value="8">8</option>
                        <option value="7">7</option>
                        <option value="6">6</option>
                        <option value="5">5</option>
                        <option value="4">4</option>
                        <option value="3">3</option>
                        <option value="2">2</option>
                        <option value="1">1</option>
                        <option value="0">0 - ei meeldinud üldse</option>
                    </select>
                </div>
                <h1 className="subtitle form-question">
                    Miks nii? Mis oli kasulik ja kas midagi häiris?
                </h1>
                <textarea
                    className="textarea"
                    name="comments"
                    ref={register({required: false})}
                    placeholder="Kirjuta siia oma kommentaarid"/>
                {Object.keys(errors).length ? <div className="validation-error">
                    Jätkamiseks vasta palun kõigile küsimustele!
                </div> : null}
                <button className={`button is-large is-rounded take-test-button ${isLoading ? 'is-loading' : ''}`}
                        disabled={isLoading}>VALMIS →
                </button>
            </form>
        </section>
    </>);
};

export default Thanks;
